import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function SignalCellular4BarIcon(props: IconProps) {
    return <Icon {...props} iconKey={"signal_cellular_4_bar"}/>
}
